/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ExternalRegistrationDataDto,
    ExternalRegistrationDataDtoFromJSON,
    ExternalRegistrationDataDtoToJSON,
    ExternalSignUpUserDto,
    ExternalSignUpUserDtoFromJSON,
    ExternalSignUpUserDtoToJSON,
    SignUpResponseDto,
    SignUpResponseDtoFromJSON,
    SignUpResponseDtoToJSON,
} from '../models';

export interface AuthExternalControllerInvestownRegisterRequest {
    externalType: string;
}

export interface AuthExternalControllerSignUpRequest {
    externalSignUpUserDto: ExternalSignUpUserDto;
}

/**
 * 
 */
export class AuthExternalApi extends runtime.BaseAPI {

    /**
     */
    async authExternalControllerInvestownRegisterRaw(requestParameters: AuthExternalControllerInvestownRegisterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ExternalRegistrationDataDto>> {
        if (requestParameters.externalType === null || requestParameters.externalType === undefined) {
            throw new runtime.RequiredError('externalType','Required parameter requestParameters.externalType was null or undefined when calling authExternalControllerInvestownRegister.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/auth-external/{externalType}/sign-up/url`.replace(`{${"externalType"}}`, encodeURIComponent(String(requestParameters.externalType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalRegistrationDataDtoFromJSON(jsonValue));
    }

    /**
     */
    async authExternalControllerInvestownRegister(requestParameters: AuthExternalControllerInvestownRegisterRequest, initOverrides?: RequestInit): Promise<ExternalRegistrationDataDto> {
        const response = await this.authExternalControllerInvestownRegisterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sign up
     */
    async authExternalControllerSignUpRaw(requestParameters: AuthExternalControllerSignUpRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SignUpResponseDto>> {
        if (requestParameters.externalSignUpUserDto === null || requestParameters.externalSignUpUserDto === undefined) {
            throw new runtime.RequiredError('externalSignUpUserDto','Required parameter requestParameters.externalSignUpUserDto was null or undefined when calling authExternalControllerSignUp.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/auth-external/sign-up`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExternalSignUpUserDtoToJSON(requestParameters.externalSignUpUserDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SignUpResponseDtoFromJSON(jsonValue));
    }

    /**
     * Sign up
     */
    async authExternalControllerSignUp(requestParameters: AuthExternalControllerSignUpRequest, initOverrides?: RequestInit): Promise<SignUpResponseDto> {
        const response = await this.authExternalControllerSignUpRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
